import * as TrovitPixel from './Trovit'

export const Trovit = TrovitPixel
